// Angular
import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRoute } from '@angular/router';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

// Shared
import { WindowRef } from 'app/_shared/window.ref';

// Environment
import { environment } from 'environments/environment';

// 3rd party
import { JwtHelperService } from '@auth0/angular-jwt';
import { AuthenticationService } from 'app/_services';

@Injectable()
export class AuthGuard implements CanActivate {
    private jwtHelper: JwtHelperService = new JwtHelperService();

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private window: WindowRef,
        private authenticationService: AuthenticationService
    ) { }

    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        console.log('AuthGuard: canActivate');
        const currentUser = this.authenticationService.currentUserValue;
        const urlToken = route.queryParams ? route.queryParams.token : undefined;
        const authenticationProvider = route.queryParams ? route.queryParams.authenticationProvider : '1';
        const userProfile = localStorage.getItem(environment.TokenName);
        const token = (userProfile == null) ? null : JSON.parse(userProfile)['token'];

        if (urlToken && !this.jwtHelper.isTokenExpired(urlToken)) {
            return true;
        } else if (currentUser && !this.jwtHelper.isTokenExpired(currentUser.token)) {
            return true;
        } else if (token != null && !this.jwtHelper.isTokenExpired(token)) {
            return true;
        } else {
            localStorage.removeItem(environment.TokenName);
            localStorage.clear();
            localStorage.setItem(environment.ReturnUrlName, state.url);

            if (authenticationProvider && authenticationProvider === '1') {
                const location = this.window.nativeWindow.location;
                const returnUrl = encodeURIComponent(`https://${location.host}/#/login`);

                localStorage.setItem(environment.AuthenticationProvider, authenticationProvider);

                setTimeout(() => {
                    window.location.href = environment.Authentication.LoginURL + returnUrl;
                }, 200);
            } else {
                this.router.navigate(['/pages/login'], { queryParams: { returnUrl: state.url } });
            }

            return false;
        }
    }
}
